import { Button, styled, Typography, Box } from '@mui/material';
import { keyframes } from '@mui/system';

export const MobileDetailsButton = styled(Button)(({ theme }) => ({
  marginTop: theme.spacing(2),
  marginBottom: theme.spacing(4),
  backgroundColor: theme.palette.secondary.main,
  '&:hover': {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.secondary.main
  },
  display: 'inline-block',
  fontsize: '0.8rem',
  height: '60px',
}))

export const MobileModalContent = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.secondary.main,
  color: theme.palette.text.primary,
  padding: theme.spacing(4),
  width: '80%',
  height: '80%',
  borderRadius: theme.shape.borderRadius,
  boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.15)',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  textAlign: 'left',
  position: 'relative',

  backgroundImage: `url('/images/mehdi_vertical.jpg')`,
  backgroundSize: 'cover',
  backgroundPosition: 'center',

  '&::before': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.7)',
    filter: 'blur(5px)',
    zIndex: 1,
  },
  '& > *': {
    position: 'relative',
    zIndex: 2,
  },
}));

const scrollRightToLeft = keyframes`
  0% { transform: translateX(100%); }
  100% { transform: translateX(-100%); }
`;

const scrollLeftToRight = keyframes`
  0% { transform: translateX(-100%); }
  100% { transform: translateX(100%); }
`;

export const MobileScrollText = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'direction',
})<{ direction: "left" | "right" }>(({ theme, direction }) => ({
  display: 'inline-block',
  textTransform: 'uppercase',
  color: 'transparent',
  WebkitTextStroke: `2px ${theme.palette.primary.main}`,
  fontWeight: 900,
  whiteSpace: 'nowrap',
  minWidth: '50%',
  animation: `${direction === 'left' ? scrollRightToLeft : scrollLeftToRight} 12s linear infinite`,
  paddingRight: '50%',

  '&:hover': {
    color: theme.palette.primary.main,
    cursor: 'pointer'
  },
}));

export const MobileBackgroundImageLeft = styled('img')(() => ({
  position: 'relative',
  width: '65vw',
  maxWidth: '320px',
  height: 'auto',
  marginBottom: '20px',
  border: '10px solid #ccc',
  boxShadow: '5px 5px 15px rgba(0, 0, 0, 0.3)',
  zIndex: 0
}))

export const MobileBackgroundImageRight = styled('img')(() => ({
  position: 'relative',
  width: '65vw',
  maxWidth: '320px',
  height: 'auto',
  border: '10px solid #ccc',
  boxShadow: '5px 5px 15px rgba(0, 0, 0, 0.3)',
  zIndex: 0
}))

export const MobileStyledFooterBox = styled(Box)(() => ({
  position: 'fixed',
  bottom: 0,
  width: '100%',
  height: '3%',
  backgroundColor: 'rgba(0, 0, 0, 0.5)',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  borderRadius: '10px',
  padding: 2,
  zIndex: 1200,
}));


export const MobileFooterColumns = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  width: '80%',
  marginTop: '1rem',
  boxSizing: 'border-box',
  marginBottom: '1rem',
  flexDirection: 'column',
  alignItems: 'center',
  padding: '0 1rem',
  textAlign: 'left'
}))